<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <rect x="0.75" y="1.06641" width="2.86364" height="2.86364" stroke="#3CB391" stroke-width="1.5"/>
    <rect x="0.75" y="6.88477" width="2.86364" height="2.86364" stroke="#3CB391" stroke-width="1.5"/>
    <rect x="0.75" y="12.7031" width="2.86364" height="2.86364" stroke="#3CB391" stroke-width="1.5"/>
    <rect x="6.56836" y="1.06641" width="2.86364" height="2.86364" stroke="#3CB391" stroke-width="1.5"/>
    <rect x="12.3862" y="1.06641" width="2.86364" height="2.86364" stroke="#3CB391" stroke-width="1.5"/>
    <rect x="6.56836" y="6.88477" width="2.86364" height="2.86364" stroke="#3CB391" stroke-width="1.5"/>
    <rect x="12.3862" y="6.88477" width="2.86364" height="2.86364" stroke="#3CB391" stroke-width="1.5"/>
    <rect x="6.56836" y="12.7031" width="2.86364" height="2.86364" stroke="#3CB391" stroke-width="1.5"/>
    <rect x="12.3862" y="12.7031" width="2.86364" height="2.86364" stroke="#3CB391" stroke-width="1.5"/>
  </svg>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'IconGridBig'
}
</script>
